// extracted by mini-css-extract-plugin
export var container = "CardsVisualization-module--container--660b3";
export var note = "CardsVisualization-module--note--eb38b";